import { Avatar } from '@shared/ui/parts/Avatar';
import { DEFAULT_TEAM_SLUG } from '@utils/static';
import { icons } from '@shared/static/icons';
import { getTotalCards } from '@utils/helpers';
import { getCryptoName } from '@utils/balance-helpers';

export function CounterIcon({ icon, value, hasBg = false }) {
  return (
    <div className={hasBg ? 'counter-icon has-bg' : 'counter-icon'}>
      {icons[icon]}
      <p>{value}</p>
    </div>
  );
}

const iconsMap = {
  cards: 'card-input',
  members: 'user-input',
};

export default function CounterTag({ data, iconType }) {
  const hasAvatar = data?.avatar || data?.slug === DEFAULT_TEAM_SLUG;
  const count =
    iconType === 'cards' ? getTotalCards(data) : data?.members_count || 0;

  return (
    <div className="counter-tag">
      {hasAvatar ? (
        <Avatar team={data} />
      ) : (
        data?.currency && icons[getCryptoName(data.currency)]
      )}
      <p>{data?.name || data?.label}</p>
      {iconType && (
        <CounterIcon icon={iconsMap[iconType]} hasBg value={count} />
      )}
    </div>
  );
}
